import React, { useRef } from 'react';
import WrappedLink from './WrappedLink';
import PropTypes from 'prop-types';
import fetch from 'isomorphic-fetch';
import get from 'lodash/get';
import { HeadingText } from '@paypalcorp/pp-react';
import { parseData } from '../../../lib/helpers';
import { useFptiImpression } from '../../../lib/hooks';

import { AMPLITUDE } from '../../../lib/constants';

const { MAIN_GET_STARTED_REC_APP_TILE_CLICK } = AMPLITUDE;

const GetStartedToolTile = ({
  category,
  fptiClick,
  fptiImpression,
  pageLink,
  tool: {
    appIcon = '',
    shortDescription = '',
    appTitle = '',
    appKey = '',
    appFPTI = '',
    location = '',
    PSClickUrl = '',
    rank = '',
    priorityScore = ''
  } = {},
  isNewLayoutEligible,
  toolTileProps: { experimentation = {} } = {}
}) => {
  const isColoredIconsEligible = get(experimentation, 'coloredIconsExp', false);
  const imgUrl = parseData(appIcon)[0] || {};
  const coloredImgUrl =
    isColoredIconsEligible && imgUrl.urlColored ? imgUrl.urlColored : '';
  const fptiObj = {
    prod: appFPTI,
    pageLink,
    categoryRank: category.rank,
    appKey,
    rank,
    priorityScore
  };
  const ref = useRef();
  useFptiImpression(ref, () => {
    fptiImpression(fptiObj);
  });

  const handleClickTool = () => {
    fptiClick({
      fptiLink: appFPTI,
      prod: appFPTI,
      pageLink,
      categoryRank: category.rank,
      appKey,
      rank,
      priorityScore,
      amplitude: true,
      event_name: MAIN_GET_STARTED_REC_APP_TILE_CLICK
    });
    fetch(PSClickUrl);
  };

  const route = `/appcenter/${category.location}/${location}`;

  const getToolTileImageStyle = () => {
    if (isNewLayoutEligible) {
      return 'category-tool-tile-image';
    }
    if (isColoredIconsEligible) {
      return 'get-started-grid-image';
    }
    return 'get-started-grid-image old';
  };

  const tickerHelper = (appTitle, className, maxLength) =>
    `${className} ${
      appTitle.replace(/\s+/g, '').length > maxLength ? 'ticker' : ''
    }`;

  return (
    <WrappedLink
      className="undo-link-styles"
      onClick={handleClickTool}
      to={route}
      ref={ref}
    >
      <div
        className={
          isNewLayoutEligible
            ? 'category-tool-tile-new'
            : 'get-started-grid-item'
        }
      >
        <div
          className={
            isNewLayoutEligible
              ? 'category-tool-tile-inner'
              : 'get-started-grid-inner'
          }
        >
          <div
            className={
              isNewLayoutEligible
                ? 'category-tool-tile-media-wrapper'
                : 'get-started-grid-media'
            }
          >
            <div
              className={`lazyload ${getToolTileImageStyle()}`}
              style={{
                background: `center center no-repeat`,
                backgroundSize:
                  isNewLayoutEligible || isColoredIconsEligible ? '100%' : '80%'
              }}
              data-bg={coloredImgUrl || imgUrl.url}
            />
          </div>
          <div
            className={
              isNewLayoutEligible
                ? 'category-tool-tile-text-wrapper'
                : 'get-started-grid-item-text'
            }
          >
            {isNewLayoutEligible ? (
              <div className="category-tool-tile-header">
                <HeadingText level={2}
                  className={tickerHelper(
                    appTitle,
                    'category-tool-tile-heading',
                    25
                  )}
                >
                  {appTitle}
                </HeadingText>
              </div>
            ) : (
              <HeadingText level={2}  className="get-started-grid-item-heading">{appTitle}</HeadingText>
            )}
            <h4
              className={
                isNewLayoutEligible
                  ? 'category-tool-tile-subheading'
                  : 'get-started-grid-item-subheading'
              }
            >
              {shortDescription}
            </h4>
          </div>
        </div>
      </div>
    </WrappedLink>
  );
};

GetStartedToolTile.propTypes = {
  category: PropTypes.object,
  fptiClick: PropTypes.func,
  fptiImpression: PropTypes.func,
  pageLink: PropTypes.string,
  tool: PropTypes.object,
  isNewLayoutEligible: PropTypes.bool,
  toolTileProps: PropTypes.object
};

export default GetStartedToolTile;
